import { ItemSpriteIds } from "../item/ItemSpriteIds";
import AnimationRowSpritesheet from "./AnimationRowSpritesheet";
import SpriteAnimation from "./SpriteAnimation";
import SpriteAnimationManager from "./SpriteAnimationManager";

export default class ItemOverlaySpritesheet extends AnimationRowSpritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     * @param {SpriteAnimationManager} spriteAnimationManager
     */
    constructor(fileName, spriteSize, spriteAnimationManager) {
        super(fileName, spriteSize)

        /**
         * @constant
         * @type {SpriteAnimationManager}
         */
        this.spriteAnimationManager = spriteAnimationManager;
        
        /**
         * The mapping of sprite animation by name.
         * @private
         * @type {{}}
         */
        this.spriteAnimationMap = {};


        // Tell the superclass to start loading the image.
        this.loadImage();
    }

    /**
     * @param {string} id
     * @returns {SpriteAnimation}
     */
    getSpriteAnimation(id) {
        return this.spriteAnimationMap[id];
    }

    /**
     * @override
     * @param {number} spriteSize
     * @returns {number}
     */
    calculateSpriteStep(spriteSize) {        
        return spriteSize; // The animation sprites do not have a gap between sprites.
    }

    /**
     * @inheritdoc
     * @override
     */
    populateSpriteMap() {

        let row = 0;

        // Thruster fire
        this.populateSpriteAnimation(ItemSpriteIds.thruster.activeOverlay, row, 5, true, true);
        row++;

        // Pick
        this.populateSpriteAnimation(ItemSpriteIds.pick.staticOverlay, row, 1, false, true);
        row++;
        this.populateSpriteAnimation(ItemSpriteIds.pick.activeOverlay, row, 4, true, true);
        row++;

        // Club
        this.populateSpriteAnimation(ItemSpriteIds.club.staticOverlay, row, 1, false, true);
        row++;
        this.populateSpriteAnimation(ItemSpriteIds.club.activeOverlay, row, 5, true, true);
        row++;

        // Axe
        this.populateSpriteAnimation(ItemSpriteIds.axe.staticOverlay, row, 1, false, true);
        row++;
        this.populateSpriteAnimation(ItemSpriteIds.axe.activeOverlay, row, 5, true, true);
        row++;

        // Broad sword
        this.populateSpriteAnimation(ItemSpriteIds.broadSword.staticOverlay, row, 1, false, true);
        row++;
        this.populateSpriteAnimation(ItemSpriteIds.broadSword.activeOverlay, row, 5, true, true);
        row++;

        this.populateSpriteAnimation(ItemSpriteIds.mace.staticOverlay, row, 1, false, true);
        row++;
        this.populateSpriteAnimation(ItemSpriteIds.mace.activeOverlay, row, 5, true, true);
        row++;

        this.populateSpriteAnimation(ItemSpriteIds.twoHandedAxe.staticOverlay, row, 1, false, true);
        row++;
        this.populateSpriteAnimation(ItemSpriteIds.twoHandedAxe.activeOverlay, row, 5, true, true);
        row++;

        this.populateSpriteAnimation(ItemSpriteIds.twoHandedClub.staticOverlay, row, 1, false, true);
        row++;
        this.populateSpriteAnimation(ItemSpriteIds.twoHandedClub.activeOverlay, row, 5, true, true);
        row++;

        this.populateSpriteAnimation(ItemSpriteIds.darkSword.staticOverlay, row, 1, false, true);
        row++;
        this.populateSpriteAnimation(ItemSpriteIds.darkSword.activeOverlay, row, 5, true, true);
        row++;

        this.populateSpriteAnimation(ItemSpriteIds.redSword.staticOverlay, row, 1, false, true);
        row++;
        this.populateSpriteAnimation(ItemSpriteIds.redSword.activeOverlay, row, 5, true, true);

        /////////////////////////////////////
        // Mark the spritesheet as loaded.
        /////////////////////////////////////

        this.loaded = true;
    }

    /**
     * @private
     * @param {string} id 
     * @param {number} row 
     * @param {number} numSprites 
     * @param {boolean} fastAnimation
     * @param {boolean} loopingAnimation
     */
    populateSpriteAnimation(id, row, numSprites, fastAnimation, loopingAnimation) {
        const animation = new SpriteAnimation(this.parseRow(row, numSprites), this.spriteAnimationManager, fastAnimation, loopingAnimation);
        this.spriteAnimationMap[id] = animation;
    }
}